import { render, staticRenderFns } from "./DateOfBirth.vue?vue&type=template&id=1228fb1a&scoped=true"
import script from "./DateOfBirth.vue?vue&type=script&lang=js"
export * from "./DateOfBirth.vue?vue&type=script&lang=js"
import style0 from "./DateOfBirth.vue?vue&type=style&index=0&id=1228fb1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1228fb1a",
  null
  
)

export default component.exports